import React from 'react'
import { ChipStyled } from './style'

const MuiChip = (props) => {
  return (
    <ChipStyled
      {...props}
    />
  )
}

export default MuiChip
